var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "ci-card ci-company-tile d-flex align-items-center",
      class: _vm.classes,
    },
    [
      _c(
        "div",
        {
          staticClass: "ci-company-tile__inner d-flex w-100 align-items-center",
        },
        [
          _vm.companyLogo
            ? _c(
                "div",
                { staticClass: "col-4 image-container" },
                [
                  _vm.company.company_url
                    ? _c(
                        "ci-router-link",
                        {
                          attrs: { to: _vm.linkWithTracking },
                          nativeOn: {
                            click: function ($event) {
                              _vm.$emit("tracking-click", {
                                targetName: "CompanyProfile",
                                targetId: _vm.company.id.toString(),
                              })
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "ci-company-tile__img" },
                            [
                              _c("ci-imgix-lazy", {
                                attrs: {
                                  url: _vm.companyLogo,
                                  params: _vm.logoParams,
                                  sizes: _vm.logoSize,
                                  "aria-description": _vm.company.name,
                                  alt: _vm.company.name,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "ci-company-tile__img" },
                        [
                          _c("ci-imgix-lazy", {
                            attrs: {
                              url: _vm.companyLogo,
                              params: _vm.logoParams,
                              sizes: _vm.logoSize,
                              "aria-description": _vm.company.name,
                              alt: _vm.company.name,
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "text-container",
              class: _vm.companyLogo ? "col-8" : "col-12",
            },
            [
              _c(
                "div",
                { staticClass: "ci-company-tile__content flex-grow-1" },
                [
                  _c("h4", {
                    staticClass: "h6 ci-company-tile__name mb-1",
                    domProps: { textContent: _vm._s(_vm.company.name) },
                  }),
                  _vm.showCounts
                    ? _c(
                        "div",
                        { staticClass: "text-sm text-muted mb-1 counts" },
                        [
                          _c("span", {
                            staticClass: "mr-3 product-count",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$tc(
                                  "company_profiles.product_count",
                                  _vm.company.products_count || 0
                                )
                              ),
                            },
                          }),
                          _c("span", {
                            staticClass: "content-count",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$tc(
                                  "company_profiles.contribution_count",
                                  _vm.company.contents_count || 0
                                )
                              ),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm.company.company_url
                    ? _c(
                        "ci-router-link",
                        {
                          staticClass: "d-block font-weight-semi mt-2 text-sm",
                          attrs: { to: _vm.linkWithTracking },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("ui.shared.go_to.company_profile")
                              ),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }